module.exports = __webpack_public_path__ + "static/assets/e6180253665b8248f685c6d96881f75b.mp3";